import GLightbox from "glightbox";
import React, {useEffect} from "react";
import {FiPlay} from "react-icons/fi";
import {FiBookOpen} from "react-icons/fi";
import data from "../data/about.json";
import {socialLink} from "../global";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";

const Authorv4 = ({isBg, book}) => {
  const {aboutv4} = data;
  useEffect(() => {
    GLightbox({
      selector: ".glightbox-book",
      slideEffect: "zoom",
      arrows: false,
    });
  }, []);

  return (
    // <!-- ========== Author section start ========== -->
    <section
      id="author"
      className={`section-padding authorv2 ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row gx-5">
          {/* <!-- author image area start --> */}
          <div
            className="col-lg-6 mb-4 mb-lg-0 d-flex justify-content-center"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="blog__single-post__image translateEffect1">
              <a
                className="img-fluid glightbox-book disable-link"
                href={book.image}
                data-glightbox="description: .book-preview; descPosition: right;"
              >
                <img
                  className="img-fluid rounded shadow"
                  src={book.image}
                  alt={book.title}
                  style={{cursor: "pointer"}}
                />
              </a>
            </div>
          </div>
          {/* <!-- author image area end --> */}
          {/* <!-- author content area start --> */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h1 className="display-4 mb-4 pt-5">{book.title}</h1>
            <p className="fw-bolder">{book.descTitle}</p>
            {book.bookDesc?.map((para, i) => (
              <p key={i}>{para}</p>
            ))}

            <a
              href={book.buyLink}
              target="_blank"
              className="smooth button button__primary me-3 mt-4 mx-auto block"
            >
              <span>Buy Now</span>
            </a>
            <a
              className="smooth button button__primary me-3 mt-4 mx-auto block glightbox-book hide"
              href={book.image}
              data-glightbox="description: .book-preview; descPosition: right;"
            >
              <span>Read the First Chapter</span>
            </a>
          </div>
          {/* <!-- author content area end --> */}
        </div>

        {/* Hidden GLightbox content */}
        <div className="glightbox-desc book-preview" style={{display: "none"}}>
          <div className="row">
            <div className="">
              <div className="row mt-5">
                <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
                  <div className="section-title-center text-center">
                    <span>One</span>
                    <h3 className="display-6 my-2">{book.chapterTitle}</h3>
                    <p className="text-muted mb-5 fs-5">
                      {book.chapterSubTitle}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <p className="first-letter">{book.firstLetter}</p>
              </div>
              {book.chapterText?.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- ========== Author section end ========== -->
  );
};

export default Authorv4;
